export default __webpack_public_path__ + "static/media/line-seq-swap-arrow-down-black.79f52384.svg";